import type { BasketType } from "../../types/BasketType";
import { getDefaultPriceObject } from "../../../../common-deprecated/constants";
import type {
    CategoryType,
    ColourType,
    ExtraBaseType,
    ExtraType,
    UpholsteryType,
    WheelType,
} from "../../../../common-deprecated/types/CommonTypes";

export const getDefaultColourObject = (): ColourType => ({
    id: "",
    shortId: "",
    code: "",
    internalCode: "",
    name: "",
    type: "",
    price: { ...getDefaultPriceObject() },
    rgb: "",
    standard: false,
    image: "",
    upholsteries: [],
    upholsteriesCarConfigurator: [],
    upholsteryOnlineAvailability: [],
    description: null,
});
export const getDefaultUpholsteryObject = (): UpholsteryType => ({
    id: "",
    objectType: "upholstery",
    shortId: "",
    internalCode: "",
    name: "",
    price: { ...getDefaultPriceObject() },
    default: false,
    standard: false,
    image: "",
    description: "",
    index: 0,
    sortIndex: 0,
    availableForColours: [],
});

export const getDefaultCategoryObject = (): CategoryType => ({
    id: "",
    name: "",
    sortIndex: 0,
    parent: null,
    root: null,
    code: "",
    level: 0,
});
export const getDefaultExtraBaseObject = (): ExtraBaseType => ({
    id: "",
    code: "",
    name: "",
    type: "option",
    price: { ...getDefaultPriceObject() },
    standard: false,
    image: "",
    included: [],
    excluded: [],
    includePacks: [],
    excludePacks: [],
    description: null,
    footNote: null,
    visualisation: [],
    availability: {
        colours: [],
        upholsteries: [],
    },
    index: 0,
    shortId: "",
    sortIndex: 0,
});
export const getDefaultExtraObject = (): ExtraType => ({
    ...getDefaultExtraBaseObject(),
    objectType: "extra",
    isWheel: false,
    showsOnCar: true,
    internalCode: "",
    path: "",
    parent: {},
    sortIndex: 0,
    colouringMode: 0,
    isUpholstery: false,
    isHidden: false,
    isPackExtra: false,
    isMobilitySolution: false,
    isCharger: false,
    exteriorColours: [],
    upholsteries: [],
    options: [],
    selectedOptionId: "",
    colour: null,
    category: { ...getDefaultCategoryObject() },
    isMostPopular: false,
    mostPopularIndex: 0,
    setItems: [],
    userSelected: false,
});

export const getDefaultWheelObject = (): WheelType => ({
    ...getDefaultExtraObject(),
    isWheel: true,
    objectType: "wheel",
    setItems: [],
});

export const getDefaultBasketObject = (): BasketType => ({
    initialized: false,
    colour: { ...getDefaultColourObject() },
    primaryAccentColour: null,
    secondaryAccentColour: null,
    upholstery: { ...getDefaultUpholsteryObject() },
    wheel: { ...getDefaultWheelObject() },
    winterWheel: null,
    extras: [],
    packs: [],
    serviceProducts: [],
    packExtras: [],
    financePacks: [],
    financePackExtras: [],
    financePackServiceProducts: [],
    // This intersection type is correct, so keep it.
    total: { ...getDefaultPriceObject(), isExternalPrice: false, discountTax: 0, discountWithoutTax: 0 },
    userSelected: [],
    userSelectedPromotions: [],
});
